import { Box, Typography } from "@mui/material";

import { MonitorZoneTiles } from "./MonitorZoneTiles";

import { LiveDataTableProps } from "../utils/groupLiveData";

type SubjectOverviewProps = {
  liveData: LiveDataTableProps[];
};

export function SubjectOverview({ liveData }: SubjectOverviewProps) {
  if (liveData.length === 0) {
    return (
      <Typography padding={4} textAlign={"center"}>
        {"No zones selected"}
      </Typography>
    );
  }

  return (
    <Box display={"flex"} flexDirection={"column"} gap={1}>
      {liveData.map((data) => (
        <MonitorZoneTiles key={data.zone} liveData={data} />
      ))}
    </Box>
  );
}
